import { render, staticRenderFns } from "./AssetIssuanceTable.vue?vue&type=template&id=4594de4e"
import script from "./AssetIssuanceTable.vue?vue&type=script&lang=js"
export * from "./AssetIssuanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports